/** Shared form-validation helpers. Errors are kept as a `field -> message` record; a field is
 * valid when its key is absent. Required fields are marked with an asterisk (NJFormItem's
 * `isRequired` for inputs, `requiredLabel()` for selects/multiselects). */
export type FormErrors<K extends string> = Partial<Record<K, string>>;

/** Appends the required asterisk to a label (for components without `isRequired`). */
export function requiredLabel(label: string): string {
  return `${label} *`;
}

export function isBlank(value: string | null | undefined): boolean {
  return !value || value.length === 0;
}

export function isValidUrl(value: string): boolean {
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function isTooLong(value: string, maxLength: number): boolean {
  return value.length > maxLength;
}

export function tooLongMessage(value: string, maxLength: number): string {
  return `Too long: ${value.length} characters (maximum ${maxLength}).`;
}

/** Live `current/max` counter shown under length-limited inputs when there is no error. */
export function lengthHint(value: string, maxLength: number): string {
  return `${value.length}/${maxLength}`;
}
